document.addEventListener("DOMContentLoaded", function () {
    const themeToggleButton = document.getElementById("theme-toggle-button");
    const sunIcon = document.getElementById("sun-icon");
    const moonIcon = document.getElementById("moon-icon");

    // Check for saved theme preference
    let theme = localStorage.getItem("theme") || "light";
    updateIcons(theme);

    themeToggleButton.addEventListener("click", function () {
        theme = theme === "dark" ? "light" : "dark";

        // Apply the theme to the body
        document.documentElement.classList.toggle("dark", theme === "dark");

        // Save the theme preference to localStorage
        localStorage.setItem("theme", theme);

        // Update the icons with animations
        updateIcons(theme);
    });

    function updateIcons(theme) {
        if (theme === "dark") {
            // Show moon, hide sun
            sunIcon.classList.remove("w-8", "h-8", "opacity-100");
            sunIcon.classList.add("w-0", "h-0", "opacity-0");
            moonIcon.classList.remove("w-0", "h-0", "opacity-0");
            moonIcon.classList.add("w-8", "h-8", "opacity-100");
        } else {
            // Show sun, hide moon
            sunIcon.classList.remove("w-0", "h-0", "opacity-0");
            sunIcon.classList.add("w-8", "h-8", "opacity-100");
            moonIcon.classList.remove("w-8", "h-8", "opacity-100");
            moonIcon.classList.add("w-0", "h-0", "opacity-0");
        }
    }
});

